/** Evento disparado após sincronização de datasets / reload de tabelas para descartar cache de catálogo em memória. */
export const RCA_CATALOG_INVALIDATE_EVENT = 'rca-catalog-invalidate';

/**
 * Se `PricesProvider` ainda não montou (ex.: sync antes das rotas com carrinho), o reset roda na próxima montagem.
 */
export const RCA_CATALOG_PENDING_INVALIDATE_SESSION_KEY = 'rca_pending_catalog_invalidate';

/**
 * Invalida catálogos em cache por cliente/escopo e preços calculados em `PricesContext`.
 * Chamar após `getLinks` / `loadFiles` concluírem e, quando aplicável, após `reloadTables()`.
 */
export function invalidateCatalogCachesAfterSync(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(RCA_CATALOG_PENDING_INVALIDATE_SESSION_KEY, '1');
  } catch {
    /* ignore quota / private mode */
  }
  window.dispatchEvent(new CustomEvent(RCA_CATALOG_INVALIDATE_EVENT));
}
